import {PointsState} from '../state/points.state';
import {Actions, POINT_VALUES_RECEIVED, POINTS_DISCOVERED} from '../actions/points.actions';
import {BacnetPoint} from '../../shared/models/point';
import {EMPTY_ID} from '../../shared/constants/empty-id';

const initialState: PointsState = {
  points: {},
  pointValues: [],
};

export function PointsReducer(state: PointsState = initialState, action: Actions): PointsState {
  let stateClone: PointsState = JSON.parse(JSON.stringify(state));

  switch (action.type) {
    case POINTS_DISCOVERED:
      let newPoints: BacnetPoint[] = JSON.parse(JSON.stringify(action.points));

      for (let p of newPoints) {
        p.ID = JSON.stringify([p.Type, p.Address]);

        let pointValue = stateClone.pointValues.find(pv => pv.PointID === p.ID);

        if (typeof pointValue === 'undefined') {
          pointValue = {
            BACnetDeviceID: EMPTY_ID,
            MotionDeviceID: EMPTY_ID,
            PointID: p.ID,
            Time: null,
            Value: null,
          };
          stateClone.pointValues.push(pointValue);
        }
      }

      stateClone.points[action.deviceId] = newPoints;
      return stateClone;
    case POINT_VALUES_RECEIVED:
      for (let i in action.pointValues) {
        let newPv = action.pointValues[i];
        let match = stateClone.pointValues.findIndex((oldPv) => {
          return oldPv.PointID === newPv.PointID && oldPv.MotionDeviceID === newPv.MotionDeviceID;
        });

        if (match > -1) {
          stateClone.pointValues[match] = newPv;
        } else {
          stateClone.pointValues.push(newPv);
        }
      }

      return stateClone;
    default:
      return state;
  }
}
